import React, { useState, useCallback, useEffect } from 'react';
import { Moment } from 'moment';
import debounce from 'lodash/debounce';

import { withRRuleData } from 'Shared/utils/withRRuleData';

import { getNextRecurDate } from './utils';

type Props = {
  days: string;
  intervalUnit: string;
  intervalAmount: string | number;
  timeOfDay: string;
  startsAt: Moment;
  dayInMonth: number;
  weekInMonth: number;
  RRule?: {};
};

function RecurNextDate({
  days,
  intervalUnit,
  intervalAmount,
  timeOfDay,
  startsAt,
  dayInMonth,
  weekInMonth,
  RRule,
}: Props) {
  const [nextRecurDateFormat, setNextRecurDateFormat] = useState(null);

  const updateNextRecurDate = useCallback(
    params => {
      const nextRecurDate = getNextRecurDate(params, RRule);
      setNextRecurDateFormat(nextRecurDate?.format('ddd, MMMM D, h:mma'));
    },
    [RRule]
  );

  const debounceUpdateNextRecurDate = useCallback(
    debounce(params => updateNextRecurDate(params), 500),
    [updateNextRecurDate]
  );

  useEffect(() => {
    debounceUpdateNextRecurDate({
      days,
      intervalUnit,
      intervalAmount,
      timeOfDay,
      startsAt,
      dayInMonth,
      weekInMonth,
    });

    return () => {
      debounceUpdateNextRecurDate.cancel();
    };
  }, [days, intervalUnit, intervalAmount, timeOfDay, startsAt, dayInMonth, weekInMonth]);

  if (!nextRecurDateFormat) return null;

  return (
    <div className="mt-3">
      <span className="text-muted">This item will next recur on</span> <b>{nextRecurDateFormat}</b>
    </div>
  );
}

export default withRRuleData(RecurNextDate);
